import * as React from 'react'

import getHostInfo from './getHostInfo'

const useHostInfo = (host: string = window.location.host) => {
    const hostInfo = React.useMemo(() => getHostInfo(host), [host])
    return hostInfo
}

export default useHostInfo